import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class StTransferService extends ApiService {

    index(params: any = {}) {
        return super.get('/st-transfers', params);
    }

    create() {
        return super.get('/st-transfers/create');
    }

    store(body: any) {
        return super.post('/st-transfers', body);
    }

    edit(stTransferId: number) {
        return super.get(`/st-transfers/${stTransferId}/edit`);
    }

    update(stTransferId: number, body: any) {
        return super.put(`/st-transfers/${stTransferId}`, body);
    }

    destroy(stTransferId: number) {
        return super.delete(`/st-transfers/${stTransferId}`);
    }

    createProductsSelect(params: any = {}) {
        return super.get(`/st-transfers/create/products/select`, params);
    }

    cancel(stTransferId: number) {
        return super.delete(`/st-transfers/${stTransferId}/cancel`);
    }
}
